import { MatStepperModule } from '@angular/material/stepper';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './components/list/list.component';
import { ListBodyComponent } from './components/list/components/list-body/list-body.component';
import { ListHeaderComponent } from './components/list/components/list-header/list-header.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { ShareCommonComponentsModule } from '@components/common/share-common-components.module';
import { CardComponent } from './components/card/card.component';
import { CardGroupComponent } from './components/card/components/card-group/card-group.component';
import { CardChatComponent } from './components/card/components/card-chat/card-chat.component';
import { NewGroupComponent } from './components/new-group/new-group.component';
import { NewChatComponent } from './components/new-chat/new-chat.component';
import { SelectUsersComponent } from './components/select-users/select-users.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CardUserComponent } from './components/card/components/card-user/card-user.component';
import { ManageGroupComponent } from './components/manage-group/manage-group.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@node_modules/@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@node_modules/@angular/material/progress-spinner';

@NgModule({
  declarations: [
    ListComponent,
    ListBodyComponent,
    ListHeaderComponent,
    CardComponent,
    CardGroupComponent,
    CardChatComponent,
    NewGroupComponent,
    NewChatComponent,
    SelectUsersComponent,
    CardUserComponent,
    ManageGroupComponent,
  ],
  exports: [ListComponent, SelectUsersComponent, CardGroupComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatExpansionModule,
    ShareCommonComponentsModule,
    MatStepperModule,
    MatProgressBarModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
  ],
})
export class InternalChatModule {}
